export default __webpack_public_path__ + "static/media/GWIAZDY_2.10894080.png";